export default {
    apiSQL: 'http://157.230.55.48',
    portSQL: 61200
}